<template>
  <!--Update 17/05/2022 15:11:46  d:\projects\newProject\src\components\Customers\usersEdit.vue-->
  <v-card :loading="loading">
    <v-card-text>
      <div align="center">
        <!-- <v-avatar size="120px"> -->
        <LangSelect class="set-language" />
        <img height="60" :src="staticPath + 'logo_tai.jpg'" />
        <!-- <br/><br/> -->
        <!-- <p>โปรดกรอก ชื่อผู้ใช้ และ รหัสผ่าน<br> -->
        <!-- <span style="font-size:12px;color:#252525">(โดยใช้ชุดเดียวกันกับตอนล็อกอินบนเครื่องคอมพิวเตอร์ที่<br>สถาบันยานยนต์)</span> -->
        <!-- </p> -->
        <!-- </v-avatar> -->
      </div>
    </v-card-text>
    <v-form ref="form" v-model="formValid" :lazy-validation="lazy" @submit.prevent>
      <v-container fluid fill-height>
        <v-row no-gutters>
          <v-col cols="12" sm="12">
            <v-row no-gutters>
              <v-col v-if="false" cols="12" sm="12" class="pr-2 text-center">
                <v-avatar width="100" height="100">
                  <img :src="apiPath + 'content/emp_img.asp?w=450&img=' + $store.state.users.main.Description + '.jpg'" class="mb-2" />
                </v-avatar>
              </v-col>
              <v-col cols="12" sm="12" class="pr-2 text-center">
                <v-text-field :dense="text_filled" :filled="text_filled" label="Email" v-model="itemSelected.username" :rules="rules.Email"></v-text-field>
              </v-col>
            </v-row>
          </v-col>

          <v-col v-if="otp" cols="12" sm="12" class="pr-2">
            <v-text-field ref="Password" type="text" label="OTP" v-model="itemSelected.OTP" :rules="rules.OTP" :dense="text_filled" :filled="text_filled" />
          </v-col>
          <v-col v-else cols="12" sm="12" class="pr-2">
            <v-text-field ref="Password" type="password" label="Old password" v-model="itemSelected.Password" :rules="rules.Password" :dense="text_filled" :filled="text_filled" />
          </v-col>
          <v-col cols="12" sm="12" class="pr-2">
            <v-text-field ref="Password" type="password" label="New password" v-model="itemSelected.newPassword" :rules="rules.newPassword" :dense="text_filled" :filled="text_filled" />
          </v-col>
          <v-col cols="12" sm="12" class="pr-2">
            <v-text-field ref="Password" type="password" label="Confirm password" v-model="itemSelected.conPassword" :rules="notmatch" :dense="text_filled" :filled="text_filled" />
          </v-col>
        </v-row>
        <v-btn block @click="resetPass()" :disabled="!formValid" :class="{ primary: formValid, error: !formValid }">เปลี่ยนรหัสผ่าน</v-btn>
      </v-container>
    </v-form>
    <v-snackbar v-model="showUpdate" timeout="3000" top @input="snackInput">
      เปลี่ยนรหัสผ่านเรียบร้อยแล้ว

      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="showUpdate = false"> ปิด </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
import itemService from '@/store/api/services/customersService'
import LangSelect from '@/components/LangSelect'
export default {
  name: 'usersResetPassword',
  components: {
    LangSelect
    // VueSignaturePad,
    // Itisopdf
  },
  props: {
    dialogClose: {
      type: Boolean
    },
    otp: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    itemSelected: {
      type: Object,
      default: function () {
        return {}
      }
    },
    action: {
      type: String,
      default: function () {
        return 'add'
      }
    }
  },
  data() {
    return {
      showUpdate: false,
      apiPath: process.env.VUE_APP_API_PATH.replace('//localhost', window.location.protocol + '//' + window.location.host.split(':')[0]),
      staticPath: process.env.VUE_APP_STATIC.replace('//localhost', window.location.protocol + '//' + window.location.host.split(':')[0]),
      // pathStatic: process.env.VUE_APP_STATIC,
      errorMessages: [],
      lazy: false,
      debug: false,
      formValid: true,
      loading: true,
      text_filled: true,
      oldItem: {},
      redirect: '',
      rules: {
        Email: [
          (val) => !!val || 'This field is required',
          (val) => {
            // email check
            const patternEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return patternEmail.test(val) || 'Invalid e-mail.'
          }
        ],
        ID: [],
        Password: [],
        OTP: [(val) => !!val || this.$t('forgot.otp_error'), (val) => ((val && val.length) || 0) === 6 || this.$t('forgot.otp_error'), (val) => !isNaN(val) || this.$t('forgot.otp_error')],
        newPassword: [(val) => ((val && val.length) || 0) <= 100 || 'ต้องไม่เกิน 100 ตัวอักษร', (val) => (val && val.length >= 8) || this.$t('login.password_error_length')],
        conPassword: [(val) => ((val && val.length) || 0) <= 100 || 'ต้องไม่เกิน 100 ตัวอักษร'],
        Activated: []
        // val => (!!val) || 'This field is required',
        // val => (!!val.toString()) || 'ห้ามเป็นค่าว่าง',
        // val => (val && val.length >= 3) || 'ต้องมีอย่างน้อย 3 ตัวอักษร',
        // val => (((val.length || 0) <= 500) ) || 'ต้องไม่เกิน 500 ตัวอักษร',
        // val => (!val.trim() || !isNaN((val)) ) || 'ต้องเป็นตัวเลข',
        // val => (Number.isInteger(parseFloat(val) ) ) || 'ต้องเป็นจำนวนเต็ม',
        // val => ((val >= 0 && val <= 999) ) || 'Number has to be between 0 and 999',

        // val => { // email check
        //   const patternEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        //   return patternEmail.test(val) || 'Invalid e-mail.'
        // },
      }
      //data()
    }
  },
  watch: {
    itemSelected: function (value, oldValue) {
      this.$nextTick(() => {
        console.log(value)
        if (value.Email !== oldValue.Email) {
          console.log('change Key')
          this.initLoad()
        }
      })
    },
    formValid: function (value) {
      this.$emit('valid', value)
    }
    //watch()
  },
  computed: {
    //computed()
    notmatch() {
      let valid = this.itemSelected.newPassword === this.itemSelected.conPassword
      if (valid) {
        return [true]
      } else {
        return ['password not match']
      }
    }
  },
  mounted: function () {
    this.initLoad()
    //mounted()
  },
  methods: {
    snackInput() {
      if (this.redirect !== '') {
        this.$router.push(this.redirect)
      }
    },
    checkPermission(permissionArray) {
      return this.$store.getters.forgot(permissionArray)
    },
    errorHandel(res) {
      if (res.status === 401) {
        this.redirect = '/signin'
        this.$router.push(this.redirect)
      }
    },
    initLoad() {
      this.loading = true
      // if (!this.$store.getters.isAuthen) {
      //   this.redirect = '/signin/?redirect=' + this.$route.path
      //   this.$router.push(this.redirect)
      // }
      // this.oldItem = Object.assign({}, this.itemSelected)
      // this.$refs.form.resetValidation()
      // if (this.action === 'add' || this.action === '') {
      //   console.log('init field for add action', this.itemSelected)
      //   // this.$refs.{{input-Date}}.setToday()
      // }
      // console.log('init', this.itemSelected)
      this.loading = false
    },
    itemCancel() {
      this.itemSelected = Object.assign({}, this.oldItem)
    },
    async resetPass() {
      this.loading = true
      if (!this.$refs.form.validate()) {
        this.loading = false
        return false
      }
      // console.log('usersEdit Save 1')
      this.redirect = ''
      var modifyDate = new Date().toISOString().slice(0, 19)
      this.itemSelected.ModifyDate = modifyDate
      // this.itemSelected.Email = this.$store.state.users.main.FullName
      // Update Event
      // console.log('usersEdit Save Update')
      let response = await itemService.forgot(this.itemSelected)
      console.log('response', response)
      if (!response.error) {
        console.log('usersEdit Save Update then OK')
        // this.itemSelected = response.data.data[0]
        // let itemSelected_update = response.data.data[0] // this.itemSelected
        this.$emit('update', response)
        this.loading = false
        this.showUpdate = true
        this.$refs.form.resetValidation()
        this.redirect = '/signin'
        // this.$router.push(this.redirect)
        return true
      } else {
        console.log('usersEdit Save Update then error')
        alert('!!เกิดข้อผิดพลาด\n' + response.error)
        this.loading = false
        return false
      }
    }
    //methods()
  }
}
</script>
<style>
.small-radio i {
  font-size: 15px;
}
.small-radio label {
  font-size: 14px;
  padding-left: 0px;
  margin-left: -4px;
}
.small-radio .v-radio {
  padding: 0px;
}
.small-radio [class*='__ripple'] {
  left: -9;
}
</style>

<style scoped>
.set-language {
  color: #fff;
  position: absolute;
  top: 3px;
  font-size: 18px;
  right: 0px;
  cursor: pointer;
}
</style>
